(function(){
if(window.__vxam)return;window.__vxam=1;
var MEM=null,busy=false;
function campoCartucho(){
 var fs=document.querySelectorAll('.product-form__input');
 for(var i=0;i<fs.length;i++){var l=fs[i].querySelector('legend,label');
  if(l&&/cartucho|embalagem|rolo|tamanho/i.test(l.textContent))return fs[i]}
 return null}
function opcoesCartucho(c){
 if(!c)return [];
 var s=c.querySelector('select');
 if(s)return [].map.call(s.options,function(o){return {v:(o.value||'').trim(),el:o,tipo:'op'}});
 return [].map.call(c.querySelectorAll('input[type=radio]'),function(r){
  var lb=c.querySelector('label[for="'+r.id+'"]');
  return {v:(r.value||'').trim(),el:r,rot:lb,tipo:'bt'}})}
function sel(){return document.querySelector('[data-vxchip-maq]')}
function carts(o){return o&&o.dataset.vxcart?o.dataset.vxcart.split('|').map(function(x){return x.trim()}):null}
function restaura(s){
 if(!MEM)return;
 var ok=[].some.call(s.options,function(o){return o.value===MEM});
 if(ok&&s.value!==MEM)s.value=MEM}
function pinta(){
 var s=sel();if(!s)return;
 var c=campoCartucho();if(!c)return;
 restaura(s);
 var op=s.options[s.selectedIndex];
 var alvo=carts(op);
 var ops=opcoesCartucho(c),primeiro=null,atualOk=false;
 ops.forEach(function(o){
  var ok=!alvo||alvo.indexOf(o.v)>-1;
  o.el.disabled=!ok;
  if(o.tipo==='op')o.el.hidden=!ok;
  else if(o.rot)o.rot.classList.toggle('vxam-off',!ok);
  if(ok){if(!primeiro)primeiro=o;
   if((o.tipo==='op'&&o.el.selected)||(o.tipo==='bt'&&o.el.checked))atualOk=true}});
 var h=document.querySelector('[data-vxchip-hint]');
 if(h){var t=op&&op.dataset.vxchipTipo;
  h.textContent=alvo?('Cartucho '+alvo.join(' ou ')+(t?' · chip '+t:'')):''}
 if(!atualOk&&primeiro&&!busy){
  busy=true;
  if(primeiro.tipo==='op'){var ss=primeiro.el.parentElement;ss.value=primeiro.v;ss.dispatchEvent(new Event('change',{bubbles:true}))}
  else{primeiro.el.checked=true;primeiro.el.dispatchEvent(new Event('change',{bubbles:true}))}
  setTimeout(function(){busy=false},300)}
}
function daCartucho(){
 var s=sel();if(!s)return;
 var c=campoCartucho();if(!c)return;
 [].forEach.call(s.options,function(o){o.disabled=false;o.hidden=false});
 var atual=null;
 opcoesCartucho(c).forEach(function(o){if((o.tipo==='op'&&o.el.selected)||(o.tipo==='bt'&&o.el.checked))atual=o.v});
 if(MEM){var ok=[].some.call(s.options,function(o){return o.value===MEM});if(ok)s.value=MEM}
 else if(atual){
  var vis=null;
  [].forEach.call(s.options,function(o){var cs=carts(o);if(!vis&&(!cs||cs.indexOf(atual)>-1))vis=o});
  if(vis)s.value=vis.value}
 pinta();
}
function minimo(){
 [].forEach.call(document.querySelectorAll('.quantity__input[data-vxmin]'),function(i){
  var m=parseInt(i.dataset.vxmin||'1',10)||1;i.min=m;
  if(!i.value||parseInt(i.value,10)<m)i.value=m;
  var b=i.parentElement.querySelector('[name=minus]');if(b)b.disabled=(parseInt(i.value,10)<=m)});
}
function rotulo(){
 [].forEach.call(document.querySelectorAll('.product-form__submit'),function(b){
  if(/adicionar ao carrinho/i.test((b.textContent||'').trim()))b.textContent='Adicionar ao Orçamento'});
}
function tudo(){daCartucho();minimo();rotulo()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',tudo);else tudo();
document.addEventListener('change',function(e){
 var s=sel();
 if(s&&(e.target===s||e.target.closest('[data-vxchip-maq]'))){MEM=s.value;pinta();return}
 var c=campoCartucho();
 if(c&&c.contains(e.target)){setTimeout(function(){daCartucho();minimo()},60);return}
 if(e.target.closest('.product-form__input,.quantity'))setTimeout(function(){minimo();rotulo()},60);
});
document.addEventListener('shopify:section:load',function(){setTimeout(tudo,60)});
var t=null;
new MutationObserver(function(){
 clearTimeout(t);t=setTimeout(function(){rotulo();daCartucho();minimo()},120);
}).observe(document.documentElement,{childList:true,subtree:true});
})();
